'use client'

import { GlobalAlertModal } from '@/components/admin/global-alert-modal'
import { AlertPortalButton } from '@/components/alert-portal'
import { DebugNotification } from '@/components/debug/DebugNotification'
import { NAV_TOPNAV } from '@/config/nav'
import { useCurrentUser } from '@/hooks/use-current-user'
import { Button } from '@heroui/react'
import { Navbar, NavbarContent } from '@/components/ui/navbar'
import { UserRole } from '@prisma/client'

import { Icon } from '@/components/ui/icon'
import React, { useState } from 'react'
import { TopNav } from './top-nav'

export type TopNavItem = (typeof NAV_TOPNAV)[0]

export interface GlobalHeaderProps {
  children?: React.ReactNode
  classNames?: {
    base?: string
    wrapper?: string
    item?: string
  }
  isSimplified?: boolean
  showAuthActions?: boolean
  showNavigation?: boolean
  notificationCount?: number
  userImage?: string | null
}

export function GlobalHeader({ children, classNames, ...props }: GlobalHeaderProps) {
  const [isDebugOpen, setIsDebugOpen] = useState(false)
  const [isGlobalAlertOpen, setIsGlobalAlertOpen] = useState(false)
  const user = useCurrentUser()
  const isAdmin = user?.role === UserRole.ADMIN

  return (
    <header className='hidden sm:block w-full opacity-50 transition-opacity duration-300 hover:opacity-100'>
      {/* Top Navigation Bar */}
      <Navbar
        id='superfluous-navbar'
        classNames={{
          base: 'group/superfluous-navbar',
          wrapper: 'w-full mx-auto px-6 flex justify-between items-center max-md:px-2 max-md:py-2 max-md:h-12 py-4',
          item: 'hidden md:flex text-xs',
          ...classNames
        }}
        height='64px'
        {...props}
      >
        <TopNav />

        <NavbarContent justify='end'>
          <div className='flex gap-2 items-center text-xs'>
            {user?.id && (
              <Button
                isIconOnly
                size='sm'
                variant='ghost'
                radius='full'
                className='bg-content2'
                onPress={() => setIsDebugOpen(true)}
                aria-label='Send Debug Notification'
              >
                <Icon icon='bug' className='w-4 h-4' />
              </Button>
            )}

            {isAdmin && (
              <Button
                isIconOnly
                size='sm'
                variant='ghost'
                className='bg-content2'
                radius='full'
                onPress={() => setIsGlobalAlertOpen(true)}
                aria-label='Create Global Alert'
              >
                <Icon icon='alert-triangle' className='w-4 h-4' />
              </Button>
            )}

            <AlertPortalButton />
          </div>
        </NavbarContent>
      </Navbar>

      {/* Debug Notification Modal */}
      <DebugNotification isOpen={isDebugOpen} onClose={() => setIsDebugOpen(false)} />

      {/* Global Alert Modal - Only for admins */}
      {isAdmin && <GlobalAlertModal isOpen={isGlobalAlertOpen} onClose={() => setIsGlobalAlertOpen(false)} />}
    </header>
  )
}

export default GlobalHeader
